module.exports = __webpack_public_path__ + "img/partner_2.51963612.png";